// App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SmartLockPage from './screens/SmartLockPage';
import { isMobile } from 'react-device-detect';
import { Container, Center, Text } from '@mantine/core';
import Lottie from 'lottie-react';
import dclogoAnimation from './assets/lottie/dclogo.json';
import errAnimation from './assets/lottie/error.json';
import { CONFIG } from './atoms/config';

function DesktopView() {
  return (
    <Container style={{ height: '100vh' }}>
    <Center style={{ height: '100%' }}>
      <div style={{ textAlign: 'center', justifyItems:'center' }}>
        <Lottie animationData={dclogoAnimation} style={{ width: 200, height: 200 }} loop={false} />
        <Text mt="md" size="lg" fw="bold">
          This feature is only available on Mobile
        </Text>
      </div>
    </Center>
  </Container>
  );
}

function Four04() {
  return (
    <Container style={{ height: '100vh' }}>
    <Center style={{ height: '100%' }}>
      <div style={{ textAlign: 'center', justifyItems:'center' }}>
        <Lottie animationData={errAnimation} style={{ width: 200, height: 200 }} loop={false} />
        <Text mt="md" size="lg" fw="bold">
          The link you used is wrong, please try again with a valid link
        </Text>
      </div>
    </Center>
  </Container>
  );
}

function App() {
  if (!isMobile && !CONFIG.devMode && !CONFIG.devLocation) {
    return <DesktopView />;
  }

  return (
    <Routes>
      <Route path="/:siteId/:lockId" element={<SmartLockPage />} />
      <Route path="*" element={<Four04 />} />
    </Routes>
  );
}

export default App;
